import { useSWR } from '~/hooks/useSWR';
import { People, TrainingReadApiClient } from '~/services/Http';

export const GET_TEAM_TRAININGS_SWR_KEY =
  'TrainingReadApiClient.getTeamTrainings';

export interface UseTeamTrainingsOutput {
  trainings?: People.TrainingDto[];
  loading: boolean;
  failedToLoad: boolean;
}

export function useGetTeamTrainings(args: {
  employeeId: string;
  lang?: string;
  offset?: number;
  limit?: number;
  order?: People.Order14;
  treeId?: string;
  roles?: string[];
  unitIds?: number[];
}): UseTeamTrainingsOutput {
  const {
    loading: teamTrainingsLoading,
    failedToLoad: failedToLoadTeamTrainings,
    data: teamTrainings,
  } = useSWR(
    [
      GET_TEAM_TRAININGS_SWR_KEY,
      args.employeeId,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.order ?? undefined,
      args?.treeId ?? undefined,
      args?.unitIds ?? undefined,
      args?.roles ?? undefined,
    ],
    ([_, employeeId, lang, offset, limit, order, treeId, unitIds, roles]) =>
      TrainingReadApiClient.getTeamTrainings(
        employeeId,
        order,
        offset,
        limit,
        lang,
        treeId,
        roles,
        unitIds,
      ).then((r) => r.data),
  );

  return {
    loading: teamTrainingsLoading,
    failedToLoad: failedToLoadTeamTrainings,
    trainings: teamTrainings,
  };
}
